<template>
  <div>
    <div class="logout" v-if="userID">
      <a href="#" @click="logout">Log out</a>
    </div>

    <div :class="'artist-new' + (userID ? ' logged-in' : '')">
      <header>
        <h1>Austin Studio Tour {{$root.year}} - Events</h1>
      </header>

      <section class="card" v-if="step === 'loading'">
        <h2>Please wait...</h2>
        <p>Loading your existing application.</p>
        <p>Not you? <a href="#" @click="logout">Log out</a></p>
      </section>

      <section class="card" v-if="step === 'login'">
        <h2 v-if="!createAccount">Log in</h2>
        <h2 v-else>Create an Account</h2>
        <p v-if="createAccount">Create an account so you can pick up where you leave off.</p>
        <p v-if="createAccount">Already started? <a href="#" @click="createAccount = false">Log in</a></p>

        <div v-on:keyup.enter="login">
          <div class="field">
            <div class="input">
              <label class="input-label">Username</label>
              <input type="text" autocomplete="none" v-model="username" class="input-field">
            </div>
          </div>
          <div class="field">
            <div class="input">
              <label class="input-label">Password</label>
              <input type="password" autocomplete="current-password" v-model="password" class="input-field">
            </div>
            <p v-if="!createAccount">Forgot password? <a href="mailto:info@bigmedium.org?subject=Forgot Password" target="_blank">Email us</a>.</p>
          </div>

          <div class="submit single">
            <button :class="'btn' + (loading ? ' loading' : '')" @click="login" :disabled="loading">Log in</button>
          </div>
        </div>
      </section>

      <section class="card" v-if="step === 0">
        <h2>Welcome</h2>
        <p>Thank you for participating in the Austin Studio Tour!<br>The Programming listing will appear only on the website.</p>
        <p>Should you have any questions regarding your registration, please reach out to <a href="mailto:trevino@bigmedium.org">trevino@bigmedium.org</a>.</p>

        <h2>Your Events</h2>
        <p v-if="!submission.events.length">No events</p>

        <div class="field other" v-for="event in submission.events" :key="event.id">
          <div class="event-info">
            <span :title="`Event #${event.id}`">{{event.program_title ? event.program_title : `Event #${event.id}`}}</span>
            <button class="edit" @click="editEvent(event.id)">Edit Event</button>
            <button class="delete" @click="deleteEvent(event.id)">Delete</button>
          </div>
        </div>

        <div class="submit">
          <button :class="'btn' + (loading ? ' loading' : '')" @click="finish" v-if="submission.events.length" :disabled="loading">Finished with Events</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="addEvent" :disabled="loading">Add Event</button>
        </div>
      </section>

      <template v-if="submission">
        <template v-for="event in submission.events">
          <div v-if="event.id == currentEvent" :key="event.id">
            <section class="card" v-if="step === 1">
              <h2>About You</h2>
              <p>This information will be used for the public listing.</p>
              <div class="field">
                <div class="input">
                  <label class="input-label">Artist First Name</label>
                  <input type="text" v-model="event.artist_first_name" class="input-field">
                </div>
              </div>
              <div class="field">
                <div class="input">
                  <label class="input-label">Artist Last Name</label>
                  <input type="text" v-model="event.artist_last_name" class="input-field">
                </div>
              </div>
              <div class="field">
                <div class="input">
                  <label class="input-label">Collaborative Name</label>
                  <input type="text" v-model="event.collaborative_name" class="input-field">
                </div>
                <p>If applicable</p>
              </div>
              <div class="field">
                <div class="input">
                  <label class="input-label">Dedicated Name</label>
                  <input type="text" v-model="event.dedicated_name" class="input-field">
                </div>
                <p>If applicable</p>
              </div>
              <div class="field">
                <div class="input">
                  <label class="input-label">Email<span class="required">*</span></label>
                  <input type="email" inputmode="url" autocomplete="email" v-model="event.email" class="input-field">
                </div>
              </div>
              <div class="submit">
                <button class="btn" @click="prevStep">Back</button>
                <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step1Valid">Save and Continue</button>
              </div>
            </section>

            <section class="card" v-if="step === 2">
              <h2>Event Details</h2>
              <p>This information will be used for the public listing.</p>
              <div class="field">
                <div class="input">
                  <label class="input-label">Title of Program<span class="required">*</span></label>
                  <input type="text" v-model="event.program_title" class="input-field">
                </div>
                <p>i.e. Big Medium Artist Panel Discussion</p>
              </div>
              <div class="field">
                <div class="input">
                  <label class="input-label">Date</label>
                  <input type="date" v-model="event.date" class="input-field">
                </div>
                <p>Programs can occur any day between November 9-17.</p>
              </div>
              <div class="field">
                <div class="input">
                  <label class="input-label">Time</label>
                  <input type="time" v-model="event.time" class="input-field">
                </div>
                <p>If applicable.</p>
              </div>
              <div class="field textarea">
                <label class="input-label">Brief description<span class="required">*</span></label>
                <textarea v-model="event.description"></textarea>
                <p :class="`char-limit${event.description.match(/\b\S+\b/g) && event.description.match(/\b\S+\b/g).length > 60 ? ' error' : ''}`">{{ event.description.match(/\b\S+\b/g) ? event.description.match(/\b\S+\b/g).length : 0 }} / 60</p>
                <p>Briefly describe your event. 60 words maximum.</p>
              </div>
              <div class="field other" v-if="schema">
                <label class="input-label">Event Category<span class="required">*</span></label>
                <div class="input-radio">
                  <label v-for="option in schema.events.items.properties.category.enum" :key="option">
                    <input type="radio" :value="option" v-model="event.category">
                    <span>{{ option }}</span>
                  </label>
                </div>
              </div>
              <div class="field other" v-if="schema">
                <label class="input-label">Event Type<span class="required">*</span></label>
                <div class="input-radio">
                  <label v-for="option in schema.events.items.properties.event_type.enum" :key="option">
                    <input type="radio" :value="option" v-model="event.event_type">
                    <span>{{ option }}</span>
                  </label>
                </div>
              </div>
              <div class="field" v-if="event.event_type === 'Other'">
                <div class="input">
                  <label class="input-label">Other<span class="required">*</span></label>
                  <input type="text" v-model="event.event_type_other" class="input-field">
                </div>
              </div>
              <div class="submit">
                <button class="btn" @click="prevStep">Back</button>
                <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step2Valid">Save and Continue</button>
              </div>
            </section>

            <section class="card" v-if="step === 3">
              <h2>Event Details</h2>
              <div class="field" v-if="event.category !== 'In-person'">
                <div class="input">
                  <label class="input-label">Additional Links</label>
                  <input type="text" v-model="event.additional_links" class="input-field">
                </div>
                <p>If applicable</p>
              </div>
              <template v-if="event.category === 'In-person'">
                <h2>Location</h2>
                <p>Must be within the boundaries, including all 10 districts of Austin, plus a 15 mile radius from the Capitol.</p>
                <div class="field other" v-if="schema">
                  <label class="input-label">How will the audience experience the art<span class="required">*</span></label>
                  <div class="input-radio">
                    <label v-for="option in schema.events.items.properties.location_experience.items.enum" :key="option">
                      <input type="checkbox" :value="option" v-model="event.location_experience">
                      <span>{{ option }}</span>
                    </label>
                  </div>
                  <p>Check all that apply</p>
                </div>
                <div v-if="event.location_experience.indexOf('By appointment or with RSVP') > -1" class="field">
                  <div class="input">
                    <label class="input-label">Appointment/RSVP Link<span class="required">*</span></label>
                    <input type="text" v-model="event.location_rsvp" class="input-field">
                  </div>
                </div>
                <div class="field other" v-if="schema">
                  <label class="input-label">Type of location<span v-if="event.location_experience.indexOf('By appointment or with RSVP') > -1 || event.location_experience.indexOf('Open to the public') > -1" class="required">*</span></label>
                  <div class="input-radio">
                    <label v-for="option in schema.events.items.properties.location_type.enum" :key="option">
                      <input type="radio" :value="option" v-model="event.location_type">
                      <span>{{ option }}</span>
                    </label>
                  </div>
                </div>
                <div class="field">
                  <div class="input">
                    <label class="input-label">Street Address<span class="required">*</span></label>
                    <input type="text" autocomplete="street-address" v-model="event.address" class="input-field">
                  </div>
                </div>
                <div class="field">
                  <div class="input">
                    <label class="input-label">Building, Suite, Unit Number</label>
                    <input type="text" autocomplete="" v-model="event.address_2" class="input-field">
                  </div>
                </div>
                <div class="field">
                  <div class="input">
                    <label class="input-label">City<span class="required">*</span></label>
                    <input type="text" autocomplete="address-level2" v-model="event.city" class="input-field">
                  </div>
                </div>
                <div class="field other" v-if="schema">
                  <label class="input-label">State<span class="required">*</span></label>
                  <select v-model="event.state">
                    <option v-for="option in schema.events.items.properties.state.items.enum" :key="option" :value="option">{{ option }}</option>
                  </select>
                </div>
                <div class="field">
                  <div class="input">
                    <label class="input-label">Zipcode<span class="required">*</span></label>
                    <input type="number" autocomplete="postal-code" v-model="event.zip" class="input-field">
                  </div>
                </div>
              </template>
              <div class="submit">
                <button class="btn" @click="prevStep">Back</button>
                <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step3Valid">Save and Continue</button>
              </div>
            </section>

            <section class="card" v-if="step === 4">
              <h2>Images</h2>
              <p>Up to five images may be uploaded, the images should be visually descriptive of your event or outdoor art. Images will only be used online.</p>

              <div class="field other" v-for="(image, index) in event.featured_images" :key="image.id">
                <label>Image {{ +index + 1 }}<span class="required" v-if="index === 0">*</span></label>

                <input v-if="!image.image" type="file" class="input-file" accept=".jpg,.jpeg,.gif" @change="prepareUploadFile($event, 'events_featured', index)">
                <div v-else class="file-info">
                  <a :href="image.image.url" target="_blank">{{ image.image.url }}</a>
                  <button class="delete" @click="deleteFile($event, 'events_featured', index)">Delete</button>
                </div>
              </div>

              <div class="submit">
                <button class="btn" @click="prevStep">Back</button>
                <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step4Valid">Save and Continue</button>
              </div>
            </section>

            <section class="card" v-if="step === 5">
              <h2>Complete</h2>
              <p>This event has been submitted. Big Medium will reach out to you if any changes need to be made. For inquiries please reach out to <a href="mailto:info@bigmedium.org">info@bigmedium.org</a></p>

              <div class="submit">
                <button class="btn" @click="prevStep">Back</button>
                <button :class="'btn' + (loading ? ' loading' : '')" @click="step = 0">Continue</button>
              </div>
            </section>
          </div>
        </template>
      </template>

      <section class="card final" v-if="step === 'finish'">
        <h2>Thank you! Your information has been received.</h2>
        <p>You may now close this window.</p>
      </section>

      <footer v-if="submission">
        <p v-if="step > 0 && step <= totalSteps">Step <span>{{ step }}</span> of <span>{{ totalSteps }}</span></p>
      </footer>
    </div>
  </div>
</template>

<script>
import Forms from "./Forms";

export default {
  name: 'events',
  components: {},
  mixins: [Forms],
  data() {
    return {
      totalSteps: 4,
      step1Valid: false,
      step2Valid: false,
      step3Valid: false,
      step4Valid: false,
      currentEvent: null,
    };
  },
  methods: {
    addEvent() {
      console.log(this.submission);
      console.log(this.submission.events);
      let eventID = Math.round(Math.random() * 100000);
      if(!this.submission.events) {
        this.submission.events = [];
        if (this.submission.events.find(event => event.id === eventID)) eventID++;
      }
      this.submission.events.push({
        id: eventID,
        artist_first_name: '',
        artist_last_name: '',
        collaborative_name: '',
        dedicated_name: '',
        email: '',
        program_title: '',
        date: '',
        time: '',
        description: '',
        category: '',
        event_type: '',
        event_type_other: '',
        additional_links: '',
        location_experience: [],
        location_rsvp: [],
        location_type: '',
        address: '',
        address_2: '',
        city: '',
        state: '',
        zip: '',
        featured_images: [
          { id: 0, image: false },
          { id: 1, image: false },
          { id: 2, image: false },
          { id: 3, image: false },
          { id: 4, image: false },
        ],
      });
      this.currentEvent = eventID;
      this.nextStep();
    },
    editEvent(id) {
      this.currentEvent = id;
      this.nextStep();
    },
    deleteEvent(id) {
      this.currentEvent = null;
      this.submission.events.splice(this.submission.events.findIndex(event => event.id === id), 1);
      this.syncUser();
    },

    validate() {
      if (!this.currentEvent) return;
      let currentEvent = this.submission.events.find(event => event.id == this.currentEvent);
      if (
        currentEvent.email.length > 0 &&
        currentEvent.email.indexOf('@') > -1
      ) {
        this.step1Valid = true;
      } else {
        this.step1Valid = false;
      }

      if (
        currentEvent.program_title.length > 0 &&
        currentEvent.description.length > 0 &&
        currentEvent.description.split(' ').length < 61 &&
        currentEvent.category.length > 0 &&
        currentEvent.event_type.length > 0 &&
        (currentEvent.event_type === 'Other' ? currentEvent.event_type_other.length > 0 : true)
      ) {
        this.step2Valid = true;
      } else {
        this.step2Valid = false;
      }


      this.step3Valid = true;
      if (currentEvent.category === 'In-person') {
        if (
          currentEvent.location_experience.length === 0 ||
          currentEvent.address.length === 0 ||
          currentEvent.city.length === 0 ||
          currentEvent.state.length === 0 ||
          currentEvent.zip.length === 0
        ) this.step3Valid = false;


        if (currentEvent.location_experience.indexOf('By appointment or with RSVP') > -1) {
          if (currentEvent.location_rsvp.length === 0) this.step3Valid = false;
        }
        if (currentEvent.location_experience.indexOf('By appointment or with RSVP') > -1 || currentEvent.location_experience.indexOf('Open to the public') > -1) {
          if (currentEvent.location_type.length === 0) this.step3Valid = false;
        }
      }

      if (currentEvent.featured_images[0].image) {
        this.step4Valid = true;
      } else {
        this.step4Valid = false;
      }
    },

    reset() {
      location.href = `/#/events-app`;
      location.reload();
    },
  }
};
</script>

<style scoped lang="less">
  html, body {
    width: auto;
    height: auto;
    overflow: initial;
    -webkit-user-select: initial;
    background-color: #F7F6F3;
  }
</style>
<style src="./Forms.less" lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/Forms/Event.vue